module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Bed-a0b8e65f5d69ed1e53bc8c0076cb7e13.svg";